import { Component, OnInit  } from '@angular/core';

@Component({
  selector: 'app-giftcard',
  templateUrl: './giftcard.component.html',
  styleUrls: ['./giftcard.component.scss']
})

export class GiftcardComponent implements OnInit   {
 
  constructor(){}

  ngOnInit(): void {
    
    };
  }

